import { useChatRooms } from "./useChatQueries";

/**
 * Total unread chat messages across all rooms. Reads from the same React
 * Query cache as the chat panel, so it stays in sync with both the global
 * Pusher subscription (cache invalidation) and direct user actions
 * (mark-as-read on focus). Pass `enabled: false` to skip the fetch when
 * the user has no access to chat (e.g. feature flag off).
 */
export function useChatUnreadCount({ enabled = true }: { enabled?: boolean } = {}): number {
  const { data: rooms } = useChatRooms({ enabled });
  return rooms?.reduce((sum, room) => sum + (room.unread_count ?? 0), 0) ?? 0;
}
